import { Container, Card, Modal, Button } from "react-bootstrap";
import { Route, Routes } from "react-router-dom";
import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { UserContext } from "context/User/UserContext";
import { ApiConfigContext } from "context/ApiConfig/ApiConfigContext";
import { useNavigate } from "react-router-dom";
import UserManagement from "./Researcher/UserManagment";
import { SubjectIndex } from "./Subject/SubjectIndex";
import { Questionnaire } from "./Subject/Questionnaire";
import { ProtectedRoute } from "components/ProtectedRoute";
import NotFound from "components/NotFound";
import { Reports } from "./Researcher/Reports";
import api from "utils/axiosInstance";
import PDFCarousel from "components/pdfcarousel/PDFCarousel";
import Modules from "./Subject/Modules";
import { Learning } from "./Subject/Modules/Learning/Learning";
import { pdfjs } from "react-pdf";
import useTracking from "../utils/useTracking";
import HRVBHandouts from "./Subject/Modules/HRVB";
import QuizReport from "./Subject/QuizReport";
import Loading from "components/Loading";
import ArithmeticTask from "./Subject/AirthmeticTask";
import StroopTask from "./Subject/StoopTask";

pdfjs.GlobalWorkerOptions.workerSrc =
  "https://unpkg.com/pdfjs-dist@4.8.69/build/pdf.worker.min.mjs";

function Base() {
  const { login, user, logout, updateTokens, setSubjectStage } =
    useContext(UserContext);
  const { routes } = useContext(ApiConfigContext);
  const navigate = useNavigate();

  const [showSessionExpired, setShowSessionExpired] = useState(false);
  const [refreshIntervalId, setRefreshIntervalId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useTracking(user);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (!user.isLoggedIn && code) {
      setLoading(true);
      const getTokensReq = {
        method: "get",
        url: routes.GET_TOKENS,
        params: {
          code: code,
        },
      };
      api(getTokensReq)
        .then((response) => {
          login({ tokens: response.data });
          updateSession({ clearSession: true });
          if (urlParams.has("code")) urlParams.delete("code");
          navigate({ search: urlParams.toString() }, { replace: true });
        })
        .catch((err) => {
          setError(err.message);
        })
        .finally(() => setLoading(false));
    }
  }, []);

  useEffect(() => {
    (async function () {
      if (user.isLoggedIn) {
        if (user.role === "subject") {
          navigate(process.env.PUBLIC_URL + "/subject");
        }
      }
    })();
  }, [user.role]);

  const renewTokens = () => {
    setLoading(true);
    const refreshToken = localStorage.getItem("refreshToken");
    const username = user.username;
    const refreshTokensReq = {
      method: "get",
      url: routes.REFRESH_TOKENS,
      params: {
        refreshToken: refreshToken,
        username: username,
      },
    };
    axios(refreshTokensReq)
      .then((response) => {
        updateTokens(response.data);
        updateSession({ clearSession: true });
      })
      .catch((err) => setError(err.message))
      .finally(() => {
        setShowSessionExpired(false);
        setLoading(false);
      });
  };

  //Need to update session if the token is nearing to expiry
  const updateSession = ({ clearSession = false, renewSession = false }) => {
    if (clearSession === true) {
      clearInterval(refreshIntervalId);
      setRefreshIntervalId(null);
    }
    if (renewSession) renewTokens();

    if (refreshIntervalId) {
      clearInterval(refreshIntervalId);
    }

    const sessionId = setInterval(
      () => {
        console.log("Session Expired");
        setShowSessionExpired(true);
      },
      60 * 60 * 1000,
    );
    setRefreshIntervalId(sessionId);
  };

  if (loading) return <Loading />;
  if (error) return <div>Error: {error}</div>;

  return (
    <>
      <Modal
        show={showSessionExpired}
        onHide={logout}
        backdrop="static"
        centered
      >
        <Modal.Header>
          <Modal.Title>Session Expired</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>Your session has expired</div>
          <div>Do you want to renew your session?</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={logout}>
            Logout
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              updateSession({ renewSession: true });
            }}
          >
            Renew Session
          </Button>
        </Modal.Footer>
      </Modal>
      <div style={{ minHeight: "80vh" }}>
        <Routes>
          <Route
            path="/dashboard"
            element={<ProtectedRoute userMeta={null} access={null} />}
          >
            <Route
              index
              element={
                <>
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100vh" }}
                  >
                    <h1 className="text-center">
                      Welcome, ! Click any item on the header to get started
                    </h1>
                  </div>
                </>
              }
            />
            <Route
              path="researcher"
              element={<ProtectedRoute userMeta={user} access="researcher" />}
            >
              <Route
                index
                element={
                  <>
                    <div
                      className="d-flex justify-content-center align-items-center"
                      style={{ height: "100vh" }}
                    >
                      <h1 className="text-center">
                        Welcome, Researcher! Click any item on the header to get
                        started
                      </h1>
                    </div>
                  </>
                }
              />
              <Route path="reports" element={<Reports />} />
              <Route path="user-management" element={<UserManagement />} />
              <Route path="tasks/arithmetic" element={<ArithmeticTask />} />
              <Route path="tasks/stroop" element={<StroopTask />} />
            </Route>
            <Route
              path="subject"
              element={<ProtectedRoute userMeta={user} access="subject" />}
            >
              <Route index element={<SubjectIndex />} />
              <Route path="edu/modules" element={<Modules />}>
                <Route path=":moduleNumber/learning" element={<Learning />} />
                <Route path=":moduleNumber/quiz" element={<Questionnaire />} />
              </Route>
              <Route path="quiz/report/:quizId?" element={<QuizReport />} />
              <Route path="hrvb/modules" element={<HRVBHandouts />} />
              {/* <Route
                path="tasks/arithmetic"
                element={<ArithmeticTask userId={user.username} />}
              />
              <Route
                path="tasks/stroop"
                element={<StroopTask userId={user.username} />}
              /> */}
            </Route>
          </Route>
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </>
  );
}

export default Base;
